import { render, staticRenderFns } from "./EntityList.vue?vue&type=template&id=12f746c2&scoped=true&"
import script from "./EntityList.vue?vue&type=script&lang=js&"
export * from "./EntityList.vue?vue&type=script&lang=js&"
import style0 from "./EntityList.vue?vue&type=style&index=0&id=12f746c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f746c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f746c2')) {
      api.createRecord('12f746c2', component.options)
    } else {
      api.reload('12f746c2', component.options)
    }
    module.hot.accept("./EntityList.vue?vue&type=template&id=12f746c2&scoped=true&", function () {
      api.rerender('12f746c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/Entity/EntityList.vue"
export default component.exports